import { render } from "./MajorHead.vue?vue&type=template&id=3572e8f0&scoped=true"
import script from "./MajorHead.vue?vue&type=script&lang=js"
export * from "./MajorHead.vue?vue&type=script&lang=js"

import "./MajorHead.vue?vue&type=style&index=0&id=3572e8f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3572e8f0"]])

export default __exports__